import { literal, number, object, string, union, z } from "zod";

export const BreadCrumbItem = union([
  object({
    label: string(),
    link: string().optional(),
    truncate: literal(false).optional(),
  }),
  object({
    label: string(),
    link: string().optional(),
    truncate: literal(true),
    width: number(),
  }),
]);

export type BreadCrumbItem = z.infer<typeof BreadCrumbItem>;
